import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const CreateContentRouteComponentLoader: LoadableType<{
	preloadWhiteboardRouteComponent?: () => void;
	preloadDatabaseRouteComponent?: () => void;
	preloadPageAndBlogRouteComponent?: () => void;
	preloadSmartLinkEmbedRouteComponent?: () => void;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-srcCreateContentRouteComponentCreateContentRouteComponentWrapper" */ '../src/CreateContentRouteComponent/CreateContentRouteComponentWrapper.tsx'
			)
		).CreateContentRouteComponentWrapper,
});
